
import Login from "./pages/Login";
import Admin from './pages/Admin';
import { useUserContext } from './contexts/UserContext';
import { useMemo } from "react";


const App = () => {
  const { user } = useUserContext();

  return useMemo(() => {
    if (user) {
      return <Admin />;
    }
  
    return <Login />;
  }, [user]);
}

export default App;
